module.exports = __webpack_public_path__ + "media/images/expert__calvin-stettler-0a98a7b45478a08e9d9b4415e98c496b.png";